import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../services/user.service';
import {first} from 'rxjs';
import {environment} from '../../../../../../environments/environment';
import {AuthService} from '../../../../../auth/services/auth.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit{

  userForm: FormGroup;
  branches: any[] = [];
  profiles: any[] = [];
  branchSelected: number | undefined;
  profileSelected: number | undefined;
  saving = false;

  loadForm = true;

  public data: any;
  id: number;
  profileName: string;
  userName: string;

  private baseUploadUrl = environment.apiBaseUrlUpload;

  defaultImg: string;
  isSubmitted = false;
  fileHad: File = null;
  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef[] = [];

  constructor(private fb: FormBuilder,
              private userService: UserService,
              private authService: AuthService,
              private translate: TranslateService,
              private toast: ToastrService,
              public route: Router,
              public router: ActivatedRoute
  ) {
    this.userForm = this.fb.group({
      firstname: ['', [Validators.required, Validators.minLength(3)]],
      lastname: ['', [Validators.required, Validators.minLength(3)]],
      phone: ['', [Validators.required, Validators.pattern(/^((?!672)\d{9}|672\d{6})$/)]],
      email: ['', [Validators.email, Validators.required]],
      username: ['', [Validators.required]],
      file: '',
      fileSource: '',
    });

  }

  ngOnInit(): void {
    this.id = this.router.snapshot.params.id;
    this.userForm.patchValue(this.data);
    // this.findBranches();
    // this.findProfiles();
    // this.loadForm = true;

    if (this.id){
      this.userService.get(this.id)
          .pipe(first())
          .subscribe(x => {
            console.log(x);
            this.userForm.patchValue(x);
            // this.branchSelected = x.branch ? x.branch['@id'] : '';
            // this.profileSelected = x.profile['@id'];
            this.profileName = x.profile.name;
            this.userName = x.username;
            this.defaultImg = x.picture;

            console.log(this.loadForm);

            this.loadForm = false;
          } );
    }
  }

  get fc(): any {
    return this.userForm.controls;
  }

  onChange(event): void{
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      this.fileHad = inputElement.files[0];
      this.userForm.patchValue({fileSource: this.fileHad});
      console.log(this.fileHad.name);
      // this.defaultImg = this.baseUploadUrl + 'uploads/' + this.fileHad.name;
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.defaultImg = event.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  onFormSubmit(): void{
    this.isSubmitted = true;
    // if (this.userForm.valid && this.fileHad && this.fileHad.name){
    if (this.userForm.valid){
      this.saving = true;
      if (this.id){
        console.log('hello maoll');

        const formData = new FormData();
        console.log(this.userForm.get('fileSource'));
        console.log(this.userForm.get('fileSource')?.value.type);
        console.log(this.userForm.get('firstname')?.value);
        formData.append('firstname', this.userForm.get('firstname')?.value);
        formData.append('lastname', this.userForm.get('lastname')?.value);
        formData.append('phone', this.userForm.get('phone')?.value);
        formData.append('email', this.userForm.get('email')?.value);
        formData.append('username', this.userForm.get('username')?.value);
        // formData.append('branch', this.userForm.get('branch')?.value);
        // formData.append('profile', this.userForm.get('profile')?.value);
        formData.append('file', this.userForm.get('fileSource')?.value);
        formData.append('fileName', this.userForm.get('fileSource')?.value.name);
        formData.append('fileSize', this.userForm.get('fileSource')?.value.size);
        formData.append('fileType', this.userForm.get('fileSource')?.value.type);

        console.log(formData);

        this.userService.editProfile(this.id, formData).subscribe({
          next: (val: any) => {
            this.toast.success(this.translate.instant('user profile') + ' ' + this.translate.instant('edited') + ' ' + this.translate.instant('successfully!'), 'Success');

            // this.activeModal.close();
            this.authService.doLogout();
          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            console.log(err['hydra:description']);

            this.saving = false;
            this.isSubmitted = false;

            if (err['hydra:code'] == 400){
                this.toast.error(this.translate.instant('This phone already exists.'))
            }  if (err['hydra:code'] == 401){
                this.toast.error(this.translate.instant('This username already exists.'))
            } 

            const errors: any[] = err;
            console.log(errors);

          }
        });
      }

    }
  }

  /* findBranches(): any{
    this.branchService.getEnableCollection().subscribe((data: any) => {
          console.log(data);
          this.branches = data['hydra:member'];
          this.branches = this.branches.map((v) => {
            v.id = v['@id'];
            return v;
          });
        },
        error => console.log(error)
    );
  }

  findProfiles(): any{
    this.profileService.getEnableCollection().subscribe((data: any) => {
          console.log(data['hydra:member']);
          this.profiles = data['hydra:member'];
          this.profiles = this.profiles.map((v) => {
            v.id = v['@id'];
            return v;
          });
        },
        error => console.log(error)
    );
  } */


}
